import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { DropDownSelector, InputDinamycPlaceholder, TextareaDynamicPlaceholder, ButtonClose, SelectExecutor, Checkbox, CheckboxToggleBlue } from "@lk-gtcom/ecomlab-components";
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { TitlePage } from '../../TitlePage/TitlePage';
import { OPTIONS_PRIORITY } from '../../../pages/ComponentsCommonTasksLogic/ModalAddTask/ModalAddTask';
import { MoonLoader } from 'react-spinners';
import './ModalTaskStatus.scss'
import { TextPage } from '../../TextPage/TextPage';
import { ModalComponent } from '../ModalComponent/ModalComponent';

const ModalTaskStatus = ({
    setIsModal,
    currentColumn,
}) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const [activeMenuItem, setAtiveMenuItem] = useState(null)
    const [triggerList, setTriggerList] = useState([])
    const [loading, setLoading] = useState(false)
    const [isCheck, setIsCheck] = useState(false)
    const [recordId, setRecordId] = useState(null)

    // Получаем id доски
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const bordId = searchParams.get('bord_id');

    // 1 - Поменять ответственного на
    const taskId = sessionStorage.getItem('crmProjectId')
    const [executorOptions, setExecutorOptions] = useState([]);
    const [executors, setExecutors] = useState([]);

    // 2 - Отправить email
    const [email, setEmail] = useState('')

    // 3 - Повысить приоритет
    const [selectedPriority, setSelectedPriority] = useState({
        label: 'Не указано',
        value: 'Не назначено',
    });

    // 4 - Поменять значение поля X на значение поле Y 
    const [fields, setFilds] = useState([]);
    const [fieldsFunnel, setFieldsFunnel] = useState([]);
    const [newValue, setNewValue] = useState('')
    const [selectedField, setSelectedField] = useState([])
    const OPTIONS_FIELDS = [...fields || [], ...fieldsFunnel || []].map(({ field_source, front_name, id }) => {
        return {
            field_source,
            label: front_name,
            value: id
        }
    })

    // 5 - Отправить email со временем
    // const [email, setEmail] = useState('')
    const [numberHours, setNumberHours] = useState(0)

    // 6 - Удалять сделки
    const [isDelete, setIsDelete] = useState(false)

    // 7 - Приоритет по времени
    // const [selectedPriority, setSelectedPriority] = useState({
    //     label: 'Не указано',
    //     value: 'Не назначено',
    // });
    // const [numberHours, setNumberHours] = useState(0)

    const resetValue = () => {
        setExecutors([])
        setEmail('')
        setSelectedPriority({
            label: 'Не указано',
            value: 'Не назначено',
        })
        setIsDelete(false)
        setNumberHours(0)
        setSelectedField([])
        setNewValue([])
    }

    // Получение триггеров
    const fetchGetTriggers = (task_type_id) => {
        let url = ` https://portals.ecomru.ru/api/crm/steps/triggers`

        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(json => {
                if (Array.isArray(json)) {
                    setTriggerList(json)
                }
            })
            .catch(err => console.error(err))
    }

    // Получение настроек триггера
    const fetchGetSettingsTriggers = (trigger_id) => {
        setLoading(true)
        let url = ` https://portals.ecomru.ru/api/crm/steps/triggers/${trigger_id}?step_id=${currentColumn?.id}`

        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(json => {
                const id = json?.id
                const {
                    field,
                    change_responsible,
                    send_email,
                    priority,
                    delete_deals,
                    hours,
                    priority_by_time,
                    send_email_by_time,
                    change_field_value_by_time
                } = json?.settings

                if (change_responsible) {
                    const cur_responsible = executorOptions.filter((item) => item?.id === change_responsible)
                    setExecutors(cur_responsible)
                    setIsCheck(true)
                }
                if (send_email || send_email_by_time) {
                    setEmail(send_email || send_email_by_time)
                    setIsCheck(true)
                }
                if (priority || priority_by_time) {
                    const curr = priority || priority_by_time
                    setSelectedPriority(OPTIONS_PRIORITY.filter((item) => item?.value == curr))
                    setIsCheck(true)
                }
                if (delete_deals) {
                    setIsDelete(delete_deals)
                    setIsCheck(true)
                }
                if (hours) {
                    setNumberHours(hours)
                    setIsCheck(true)
                }
                if (change_field_value_by_time) {
                    setNewValue(change_field_value_by_time)
                    setIsCheck(true)
                }
                if (field) {
                    setSelectedField(OPTIONS_FIELDS.filter((item) => {
                        return item?.value == field
                    }))
                    setIsCheck(true)
                }
                setRecordId(id)
                setLoading(false)
            })
            .catch(err => {
                setIsCheck(false)
                setLoading(false)
            })
    }

    // Установка настроек
    const fetchSetSettingsTriggers = (trigger_id, key_name) => {
        let url = ` https://portals.ecomru.ru/api/crm/steps/trigger/create`

        const current = activeMenuItem?.id
        const current_1 = current === 1 ? { [key_name]: executors?.[0]?.id } : {}
        const current_2 = current === 2 ? { [key_name]: email } : {}
        const current_3 = current === 3 ? { [key_name]: selectedPriority?.value } : {}
        const current_4 = current === 4 ?
            {
                hours: numberHours,
                field_type: selectedField?.field_source,
                field: selectedField?.value,
                change_field_value_by_time: newValue
            }
            : {}
        const current_5 = current === 5 ? { [key_name]: email, hours: numberHours } : {}
        const current_6 = current === 6 ? { [key_name]: isDelete } : {}
        const current_7 = current === 7 ? { [key_name]: selectedPriority?.value, hours: numberHours } : {}

        const body = JSON.stringify({
            step_id: currentColumn?.id,
            trigger_id,
            settings: {
                ...current_1,
                ...current_2,
                ...current_3,
                ...current_4,
                ...current_5,
                ...current_6,
                ...current_7
            }
        })

        fetch(url, { method: 'POST', headers, body })
            .then(res => res.json())
            .then(json => {
                console.log(json)

            })
            .catch(err => {
                alert('Не удалось сохранить триггер')
                console.error(err)
            })
    }

    // Изменение настроек
    const fetchChangeSettingsTriggers = (key_name, value_executors) => {
        let url = ` https://portals.ecomru.ru/api/crm/steps/trigger/update`


        const current = activeMenuItem?.id

        const current_1 = current === 1 ? { [key_name]: value_executors } : {}
        const current_2 = current === 2 ? { [key_name]: email } : {}
        const current_3 = current === 3 ? { [key_name]: selectedPriority?.value } : {}
        const current_4 = current === 4 ?
            {
                hours: numberHours,
                field_type: selectedField?.field_source,
                field: selectedField?.value,
                change_field_value_by_time: newValue
            }
            : {}
        const current_5 = current === 5 ? { [key_name]: email, hours: numberHours } : {}
        const current_6 = current === 6 ? { [key_name]: !isDelete } : {}
        const current_7 = current === 7 ? { [key_name]: selectedPriority?.value, hours: numberHours } : {}
        const body = JSON.stringify({
            record_id: recordId,
            settings: {
                ...current_1,
                ...current_2,
                ...current_3,
                ...current_4,
                ...current_5,
                ...current_6,
                ...current_7
            }
        })

        fetch(url, { method: 'PATCH', headers, body })
            .then(res => res.json())
            .then(json => {
                console.log(json)
            })
            .catch(err => {
                alert('Не удалось сохранить триггер')
                console.error(err)
            })
    }

    // Удаление настроек
    const fetchDeleteTriggers = (record_id) => {
        if (!record_id) return
        let url = ` https://portals.ecomru.ru/api/crm/steps/triggers/${record_id}?step_id=${currentColumn?.id}`

        fetch(url, { method: 'DELETE', headers })
            .then(res => res.json())
            .then(json => {
                console.log(json)
            })
            .catch(err => console.error(err))
    }

    // Получить участников проекта 
    const fetchPossibleAttendees = () => {
        const url = ` https://portals.ecomru.ru/api/crm/projects/${taskId}/attendees?can_be_add=false`;

        fetch(url, { headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad attendees response');
                }
            })
            .then((json) => {
                setExecutorOptions(json);
            })
            .catch((e) => console.error(e));
    };

    // Получение полей проекта
    const fetchGetAdditionalFields = (abortController = new AbortController(), page) => {

        let url = ` https://portals.ecomru.ru/api/crm/projects/get_additional_field/${taskId}`

        fetch(url, {
            method: 'GET',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setFilds(json?.map(({ name, id, type, possible_values }) => ({ front_name: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, data_type: type, id: id, possible_values: possible_values, field_source: 'project' })))
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение полей воронки
    const fetchGetAdditionalFieldsFunnel = (
        abortController = new AbortController()
    ) => {
        let url = ` https://portals.ecomru.ru/api/crm/funnels/get_additional_field/${bordId}`

        fetch(url, {
            method: 'GET',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setFieldsFunnel(json?.map(({ name, id, type, possible_values, field_source }) =>
                    ({ front_name: <><span style={{ fontWeight: 600 }}>ID-{id} / </span>{name}</>, data_type: type, id: id, possible_values: possible_values, field_source: 'funnel' })))
            })
            .catch((err) => {
                console.error(err);
            });
        // .finally(() => {
        //     setLoad(false)
        // })
    };

    useEffect(() => {
        fetchGetTriggers()
        fetchPossibleAttendees()
        fetchGetAdditionalFields()
        fetchGetAdditionalFieldsFunnel()
    }, []);


    useEffect(() => {
        if (activeMenuItem?.id) {
            resetValue()
            setTimeout(() => fetchGetSettingsTriggers(activeMenuItem?.id), 0)
        }
    }, [activeMenuItem]);

    return (
        <ModalComponent
            title={<>Настройки сделок в колонке <span style={{ color: '#22C55E' }}>"{currentColumn?.name}"</span></>}
            onClose={e => setIsModal(false)}
            styleContent={{
                padding: 0
            }}
            child={
                <div className='modal-task-status'>
                    <div className='modal-task-status__content'>
                        <nav className='modal-task-status__sidebar'>
                            <ul>
                                {triggerList?.map(({ id, key, name }) => {
                                    return <li key={id}>
                                        <button
                                            className={activeMenuItem?.key == key ? 'btn-point_active' : 'btn-point'}
                                            onClick={(e) => {
                                                setAtiveMenuItem({ key, id, name })
                                            }}
                                        >{name}</button>
                                    </li>
                                }
                                )}
                            </ul>
                        </nav>

                        <main className='modal-task-status__main'>
                            <TitlePage
                                medium
                                title={<>Параметры триггера:</>}
                            />



                            {loading ? <MoonLoader
                                color="#7b7b7b"
                                speedMultiplier={0.5}
                            /> :
                                <div className='modal-task-status__main-content'>
                                    {(activeMenuItem?.id) && <div className='modal-task-status__toolbar'>
                                        <TitlePage
                                            medium
                                            title={<span style={{ color: '#22C55E' }}> {activeMenuItem?.name}</span>}
                                        />

                                        <div className='modal-task-status__label'>
                                            <TextPage
                                                text='Активировать триггер'
                                            />

                                            <CheckboxToggleBlue
                                                value={isCheck}
                                                onChange={(e) => {
                                                    if (e) {
                                                        fetchSetSettingsTriggers(activeMenuItem?.id, activeMenuItem?.key)
                                                    } else {
                                                        fetchDeleteTriggers(recordId)
                                                    }
                                                    setIsCheck(!isCheck)
                                                }}
                                            />
                                        </div>

                                    </div>}


                                    {/* 1 - Поменять ответственного на */}

                                    {activeMenuItem?.id === 1 &&
                                        <div className='modal-task-status__select-group'>
                                            <SelectExecutor
                                                executors={executors}
                                                setExecutors={(e) => {
                                                    setExecutors(e);
                                                }}
                                                onAddExecutor={(e) => {
                                                    if (isCheck && e) {
                                                        fetchChangeSettingsTriggers(activeMenuItem?.key, e)
                                                    }
                                                }}
                                                executorOptions={executorOptions}
                                                title="Ответственный"
                                                placeholder="Назначить"

                                            />
                                        </div>}

                                    {/* 2 - Отправить email */}

                                    {activeMenuItem?.id === 2 && <div className='modal-task-status__select-group'>

                                        <div style={{ width: '100%' }}
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        >
                                            <TextareaDynamicPlaceholder
                                                returnArr
                                                changeValue={email}
                                                width={'100%'}
                                                placeholder="Введите списки email-ов через Enter"
                                                onChange={(e) => setEmail(e)}
                                            />
                                        </div>

                                    </div>}

                                    {/* 3 - Повысить приоритет */}

                                    {activeMenuItem?.id === 3 && <DropDownSelector
                                        options_prop={OPTIONS_PRIORITY}
                                        placeholder="Приоритет"
                                        isClearable={false}
                                        state={selectedPriority}
                                        setState={setSelectedPriority}
                                        onBlur={(e) => {
                                            if (isCheck) {
                                                fetchChangeSettingsTriggers(activeMenuItem?.key)
                                            }
                                        }}
                                    />}

                                    {/* 4 - Поменять значение поля X на значение поле Y */}
                                    {activeMenuItem?.id === 4 && <div className='modal-task-status__select-group'>

                                        <DropDownSelector
                                            options_prop={OPTIONS_FIELDS}
                                            placeholder="Поле"
                                            isClearable={false}
                                            state={selectedField}
                                            setState={setSelectedField}
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        />


                                        <InputDinamycPlaceholder
                                            changeValue={newValue}
                                            onChange={(e) => setNewValue(e)}
                                            size='s'
                                            placeholder='Новое значение поля'
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        />

                                        <InputDinamycPlaceholder
                                            changeValue={numberHours}
                                            onChange={(e) => setNumberHours(e)}
                                            type='number'
                                            size='s'
                                            placeholder='Количество часов нахождения в шаге'
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        />
                                    </div>}

                                    {/* 5 - Отправить email со временем */}

                                    {activeMenuItem?.id === 5 &&
                                        <div className='modal-task-status__select-group'>
                                            <div style={{ width: '100%' }}
                                                onBlur={(e) => {
                                                    if (isCheck) {
                                                        fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                    }
                                                }}
                                            >
                                                <TextareaDynamicPlaceholder
                                                    returnArr
                                                    changeValue={email}
                                                    width={'100%'}
                                                    placeholder="Введите списки email-ов через Enter"
                                                    onChange={(e) => setEmail(e)}

                                                />
                                            </div>



                                            <InputDinamycPlaceholder
                                                changeValue={numberHours}
                                                onChange={(e) => setNumberHours(e)}
                                                type='number'
                                                size='s'
                                                placeholder='Количество часов нахождения в шаге'
                                                onBlur={(e) => {
                                                    if (isCheck) {
                                                        fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                    }
                                                }}
                                            />
                                        </div>
                                    }

                                    {/* 6 - Удалять сделки */}

                                    {activeMenuItem?.id === 6 && <div className='modal-task-status__select-group'>
                                        <Checkbox
                                            value={isDelete}
                                            onChange={(checked) => {
                                                setIsDelete(checked)
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        >Удалять сделки</Checkbox>
                                    </div>}

                                    {/* 7 - Приоритет по времени */}

                                    {activeMenuItem?.id === 7 && <div className='modal-task-status__select-group'>
                                        <DropDownSelector
                                            options_prop={OPTIONS_PRIORITY}
                                            placeholder="Приоритет"
                                            isClearable={false}
                                            state={selectedPriority}
                                            setState={setSelectedPriority}
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        />

                                        <InputDinamycPlaceholder
                                            changeValue={numberHours}
                                            onChange={(e) => setNumberHours(e)}
                                            type='number'
                                            size='s'
                                            placeholder='Количество часов нахождения в шаге'
                                            onBlur={(e) => {
                                                if (isCheck) {
                                                    fetchChangeSettingsTriggers(activeMenuItem?.key)
                                                }
                                            }}
                                        />
                                    </div>}


                                </div>
                            }

                        </main>
                    </div>
                </div>
            }
        />
    )
}

export { ModalTaskStatus }